import { render, staticRenderFns } from "./JoinUsLayer.vue?vue&type=template&id=272c7e6c&scoped=true"
import script from "./JoinUsLayer.vue?vue&type=script&lang=js"
export * from "./JoinUsLayer.vue?vue&type=script&lang=js"
import style0 from "./JoinUsLayer.vue?vue&type=style&index=0&id=272c7e6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272c7e6c",
  null
  
)

export default component.exports